import {
  getApp,
  getApps,
  initializeApp,
  type FirebaseApp,
  type FirebaseOptions,
} from "firebase/app";
import {
  initializeAppCheck,
  getToken as getAppCheckToken,
  ReCaptchaEnterpriseProvider,
  type AppCheck,
} from "firebase/app-check";
import { getAuth, type Auth } from "firebase/auth";
import { assertFirebaseEnvironment, env } from "./env";

let appCheckInstance: AppCheck | undefined;

function required(value: string | undefined, name: string): string {
  if (!value) throw new Error(`Eksik portal yapılandırması: ${name}`);
  return value;
}

function getFirebaseApp(): FirebaseApp {
  assertFirebaseEnvironment();
  if (getApps().length > 0) return getApp();

  const options: FirebaseOptions = {
    apiKey: required(env.firebaseApiKey, "VITE_FIREBASE_API_KEY"),
    authDomain: required(env.firebaseAuthDomain, "VITE_FIREBASE_AUTH_DOMAIN"),
    projectId: required(env.firebaseProjectId, "VITE_FIREBASE_PROJECT_ID"),
    appId: required(env.firebaseAppId, "VITE_FIREBASE_APP_ID"),
  };
  if (env.firebaseStorageBucket) options.storageBucket = env.firebaseStorageBucket;
  if (env.firebaseMessagingSenderId) options.messagingSenderId = env.firebaseMessagingSenderId;
  return initializeApp(options);
}

export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}

function getFirebaseAppCheck(): AppCheck {
  if (appCheckInstance) return appCheckInstance;
  assertFirebaseEnvironment();
  appCheckInstance = initializeAppCheck(getFirebaseApp(), {
    provider: new ReCaptchaEnterpriseProvider(
      required(env.recaptchaEnterpriseSiteKey, "VITE_RECAPTCHA_ENTERPRISE_SITE_KEY"),
    ),
    isTokenAutoRefreshEnabled: true,
  });
  return appCheckInstance;
}

export async function acquireAppCheckToken(): Promise<string> {
  const result = await getAppCheckToken(getFirebaseAppCheck(), false);
  return result.token;
}
